module.exports = __webpack_public_path__ + "static/media/subGoogle3.0f94f0f5.png";